module.exports = __webpack_public_path__ + "img/active-11.c20a288d.svg";